export const SETCOMPLAINTSLIST = "SETCOMPLAINTSLIST";
export const SETCOMPLAINTLISTBYID = "SETCOMPLAINTLISTBYID";
export const SETCOMPLAINTSLISTDATA = "SETCOMPLAINTSLISTDATA";
export const SETPRODUCTCATEGORY = "SETPRODUCTCATEGORY";
export const SETCOMPLAINTSCATEGORY = "SETCOMPLAINTSCATEGORY";
export const SETCUSTOMERLIST = "SETCUSTOMERLIST";
export const SETCOMPLAINTSCOUNT = "SETCOMPLAINTSCOUNT";
export const SETCUSTOMERINVOICELIST = "SETCUSTOMERINVOICELIST";
export const SETCUSTOMERITEMLIST = "SETCUSTOMERITEMLIST";
export const SETCOMPLAINTSCOMMENTS = "SETCOMPLAINTSCOMMENTS";
export const SETCOMPLAINTATTACHMENTDATA = "SETCOMPLAINTATTACHMENTDATA";
